import { memo } from 'react';

import { Flex, type FlexProps } from '../flex/flex.tsx';

type HStackProps = Omit<FlexProps, 'direction'>;

export const HStack = memo((props: HStackProps) => <Flex direction="row" {...props} />);
